import _ from 'lodash'

export default class BlackBoxDistancia{
    constructor(){
        this.listaComuna = []
        this.filtroComuna = []
    }
    reset(){
        this.listaComuna = []
        this.filtroComuna = []
    }
    add(comunasRow){
        this.listaComuna.push(comunasRow)
    }
    ordenar(){
        let porComuna = (comuna)=> comuna.nombre
        this.listaComuna = _.orderBy(this.listaComuna, [porComuna], ['asc'])
    }
    actualizarFiltros(){
        this.filtroComuna = _.chain(this.listaComuna)
            .map(comuna=>{
                let valor = comuna.cutComuna
                let texto = comuna.nombre

                let opcion = _.find(this.filtroComuna, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado:true}
            })
            .uniqBy('valor')
            .sortBy('texto')
            .value()       
    }
    reemplazarFiltro(nombreFiltro, filtroActualizado){
        if(this[nombreFiltro]){
            this[nombreFiltro] = filtroActualizado
        }else{
            console.error(`Filtro ${nombreFiltro} no existe`)
        }
    }
    getListaFiltrada(){
        this.actualizarFiltros()

        return{
            comunasRow: _.chain(this.listaComuna)
                .filter(comuna=>{
                    return _.find(this.filtroComuna, {'valor': comuna.cutComuna, 'seleccionado': true})
                }).value(),
            filtrosComunas: {
                filtroComuna: this.filtroComuna
            },
            listaComuna: this.listaComuna
        }
    }
}


// WEBPACK FOOTER //
// ./frontEnd/admin/distancias/BlackBoxDistancia.js